import { classNames } from 'primereact/utils';
import { SkeletonProps } from 'primereact/skeleton';

export const PTSkeleton = {
  root: ({ props }: { props: SkeletonProps }) => ({
    className: classNames('ax-skeleton', {
      'ax-skeleton-circle': props.shape === 'circle',
    }),
  }),
};
